import { FunctionComponent, useEffect, useState } from 'react';
import SubscriptionForm from './SubscriptionForm/SubscriptionForm';
import {
	SubscriptionFormState,
	useSubscriptionFormContext,
} from './SubscriptionForm/SubscriptionFormContext';
import { H1, RoundSpinner } from '@montel/montelpro-shared-components-v2';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { SUBSCRIPTIONS_API_ROUTE } from 'apiRoutes';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import moment from 'moment';
import { SubscriberType } from 'domain/subscription/interfaces/SubscriberType';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';

const EditSubscriptionPage: FunctionComponent = () => {
	const {
		activeSubscription,
		setSubscriptionFormState,
		setActiveSubscription,
	} = useSubscriptionFormContext();
	const [companyId, setCompanyId] = useState<number>();
	const [isSystemEntity, setIsSystemEntity] = useState<boolean>();

	const { id } = useParams();
	const [searchParams] = useSearchParams();

	useEffect(() => {
		const isSystemEntity = searchParams.get('isSystemEntity');
		setIsSystemEntity(Boolean(isSystemEntity));

		const companyId = searchParams.get('companyId');

		const numberifiedCompanyId = Number(companyId);
		if (!activeSubscription?.companyId && numberifiedCompanyId) {
			setCompanyId(numberifiedCompanyId);
		}
	}, [searchParams]);

	const { toApplicationPermissions, permissionOptionsLoaded } =
		useGlobalContext();

	const toSubscriptionFormState = (
		subscription: Subscription,
	): SubscriptionFormState => ({
		startDate: moment(subscription.startDate),
		endDate: moment(subscription.endDate),
		seats: subscription.seats,
		type: subscription.type,
		description: subscription.description,
		applicationPermissions: toApplicationPermissions(
			subscription.applicationPermissions,
		),
	});

	useEffect(() => {
		if (!permissionOptionsLoaded) return;

		async function getSubscription() {
			const response = await axios.get(
				`${SUBSCRIPTIONS_API_ROUTE}/GetSubscription?SubscriptionId=${id}`,
			);

			setActiveSubscription(response.data);
			setSubscriptionFormState(toSubscriptionFormState(response.data));
		}

		activeSubscription && activeSubscription.id == Number(id)
			? setSubscriptionFormState(
					toSubscriptionFormState(activeSubscription),
			  )
			: getSubscription();
	}, [permissionOptionsLoaded]);

	return (
		<>
			<H1>Edit subscription</H1>
			{activeSubscription ? (
				<SubscriptionForm
					edit
					subscriberType={
						Boolean(isSystemEntity)
							? SubscriberType.SystemEntity
							: SubscriberType.Account
					}
					assignToCompanyId={companyId}
				/>
			) : (
				<RoundSpinner />
			)}
		</>
	);
};

export default EditSubscriptionPage;
